import {Component, Input, OnInit} from '@angular/core';
import {GalleryData} from "./gallery-data";
import {GalleryItemData} from "./gallery-item-data";
import {OverlayService} from "../../overlay/overlay.service";
import {GalleryComponent} from "../gallery/gallery.component";

@Component({
  selector: 'brt-gallery-preview',
  templateUrl: './gallery-preview.component.html',
  styleUrls: ['./gallery-preview.component.scss']
})
export class GalleryPreviewComponent implements OnInit{

  @Input('data') set setData(val: GalleryData) {
    this.data = val;

    this.isSingleItem = this.data.items.length === 1;
  }

  data!: GalleryData;
  isSingleItem = false;

  constructor(private overlay: OverlayService) {
  }
  ngOnInit() {
    // console.log(this.data);
  }

  openOverlay() {
    if(!this.isSingleItem) {
      this.overlay.addComponent({component: GalleryComponent, data: {data: this.data}});
    }
  }
}
